// @ts-nocheck
// frontend/packages/volto-fhnw-web25-base/src/customizations/volto/components/manage/Contents/utils/columnsStorage.js

import keys from 'lodash/keys';
import indexOf from 'lodash/indexOf';
import mapValues from 'lodash/mapValues';
import Indexes, { defaultIndexes } from '@plone/volto/constants/Indexes';

/**
 * Storage key for persisting column configuration in localStorage
 */
export const CONTENTS_COLUMNS_STORAGE_KEY = 'volto-contents-columns';

/**
 * Load saved columns configuration from localStorage
 * Merges saved configuration with current Indexes to handle added/removed columns
 * @returns {Object|null} Column configuration object or null if not found/invalid
 */
export const loadSavedColumns = () => {
  if (typeof window === 'undefined') return null;
  try {
    const saved = localStorage.getItem(CONTENTS_COLUMNS_STORAGE_KEY);
    if (!saved) return null;
    const parsed = JSON.parse(saved);
    if (!parsed.order || !parsed.values) return null;

    // Merge with current Indexes
    const currentKeys = keys(Indexes);
    const mergedValues = {};
    let selectedCount = 1;

    currentKeys.forEach((key) => {
      const savedVal = parsed.values[key];
      if (savedVal && Indexes[key]) {
        mergedValues[key] = { ...Indexes[key], selected: savedVal.selected };
        if (savedVal.selected) selectedCount++;
      } else {
        mergedValues[key] = {
          ...Indexes[key],
          selected: indexOf(defaultIndexes, key) !== -1,
        };
        if (indexOf(defaultIndexes, key) !== -1) selectedCount++;
      }
    });

    const mergedOrder = [
      ...parsed.order.filter((k) => currentKeys.includes(k)),
      ...currentKeys.filter((k) => !parsed.order.includes(k)),
    ];

    return { order: mergedOrder, values: mergedValues, selectedCount };
  } catch {
    return null;
  }
};

/**
 * Save columns configuration to localStorage
 * Only persists the 'selected' state to minimize storage usage
 * @param {Object} index - Column configuration object with order, values, and selectedCount
 */
export const saveColumnsToStorage = (index) => {
  if (typeof window === 'undefined') return;
  try {
    const data = {
      order: index.order,
      values: mapValues(index.values, (v) => ({ selected: v.selected })),
      selectedCount: index.selectedCount,
    };
    localStorage.setItem(CONTENTS_COLUMNS_STORAGE_KEY, JSON.stringify(data));
  } catch {
    // Silently fail if localStorage is not available
  }
};

/**
 * Get default column configuration based on Indexes
 * @returns {Object} Default column configuration
 */
export const getDefaultColumnConfig = () => ({
  order: keys(Indexes),
  values: mapValues(Indexes, (value, key) => ({
    ...value,
    selected: indexOf(defaultIndexes, key) !== -1,
  })),
  selectedCount: defaultIndexes.length + 1,
});
